module.exports = {
  psychologicalHotline: {
    psychologicalHotline: '心理热线',
    provinceHint: '请选择省份',
    area: '区域',
    areaHint: '请填写区域',
    content: '联系方式',
    contentHint: '请填写联系方式',
    phoneHint: '请填写正确的联系方式',
    organizer: '主办单位',
    organizerHint: '请填写主办单位',
    psychologicalHotlineList: '热线列表',
    provinceTable: '适用省份/直辖市',
    psychologicalHotlineName: '热线名称',
    psychologicalHotlineNameHint: '请填写热线名称',
    psychologicalHotlineTime: '开通时段',
    psychologicalHotlineTimeHint: '请选择开通时段',
    psychologicalHotlineSource: '热线来源',
    remark: '备注',
    remarkHint: '请填写备注',
    addPsychologicalHotline: '添加热线',
    editPsychologicalHotline: '编辑热线',
    psychologicalHotlineInfo: '热线信息',
    deleteDictHint: "热线 {0} 删除后将不可恢复，确定吗？",
  }
}


// WEBPACK FOOTER //
// ./src/i18n/psychologicalHotline/zh-CN.js